import Styles from './MobileTopBar.module.scss'
import { Modal, useModals } from 'almanac-ui/Modal'
import { ConnectedSearchInput as SearchInput, Props as SearchInputProps } from '../SearchInput/SearchInput'
import { connectSearchBox } from 'react-instantsearch-dom'
import { AlmanacFile } from 'types'

interface Props extends SearchInputProps {
  initialValues?: {
    project?: AlmanacFile | null
  }
}

const MobileTopBar = ({ ...props }: Props) => {
  const { closeModal } = useModals()

  return (
    <>
      <Modal.Header title="Search" onClose={closeModal} />
      <div className={Styles.wrapper}>
        <div className={Styles.input}>
          <SearchInput {...props} />
        </div>
      </div>
    </>
  )
}

export const ConnectedMobileTopBar: React.ComponentClass<any, Props> = connectSearchBox(MobileTopBar)
